import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import { Row } from 'react-bootstrap'
import { Col } from 'react-bootstrap'

import PieChart from '../PieChart'
import RestrictableButton from '../../../../shared/components/Instructor/RestrictableButton'

import panelStyle from 'Styles/panel.css'
import style from './style.css'
import colors from 'Styles/baseColors.css'

export default class TargetScoreSummary extends Component {
  pieChartSlices () {
    const notStarted = this.props.totalStudents - this.props.startedStudents
    const startedNotCompleted = this.props.startedStudents - this.props.completedStudents

    return (
      [
        {
          color: colors.colorBlueLighter,
          value: startedNotCompleted
        },
        {
          color: colors.colorBlueDarker,
          value: this.props.completedStudents
        },
        {
          color: '#fff',
          value: notStarted
        }
      ]
    )
  }

  renderButton () {
    return (
      <RestrictableButton
        id="targetScoreEditBtn"
        clickEventHandler={this.props.onEditTargetScoreClick}
        hidden={false}
        tabIndex={0}
        dataTestId="targetScoreEditBtn"
        restricted={this.props.isRestrictedInstructor}
        buttonText="Edit Target"
        ariaLabel="Edit Target"
      />
    )
  }

  render () {
    const startedNotCompleted = this.props.startedStudents - this.props.completedStudents
    return (
      <div className={classnames(panelStyle.large, style.panel)}>
        <Row>
          <Col lg={12} className={style.smallGutter}>
            <p className={style.targetScoreHeader}>Target Score Completion</p>
          </Col>
        </Row>
        <Row>
          <Col xs={4} md={5} lg={5} className={style.smallGutter}>
            <p className={style.targetScoreLabel}>Target Score:</p>
            <p className={style.targetScore}>{this.props.scoreTarget} pts</p>
            <div>
              {!this.props.individualStudentSelected ? this.renderButton() : null}
            </div>
          </Col>

          <Col xs={4} md={3} lg={3} className={style.smallGutterPie}>
            <div className={style.pieChartCol}>
              <PieChart
                slices={this.pieChartSlices()}
                borderColor={colors.colorGrayMediumDark}
              />
            </div>
            {this.props.browser.lessThan.medium
              ? <ul className={style.list}>
                <li className={style.startedStudentsBullet}>
                  <span>Started ({startedNotCompleted})</span>
                </li>
                <li className={style.completedStudentsBullet}>
                  <span>Completed ({this.props.completedStudents})</span>
                </li>
              </ul>
              : null}
          </Col>
          <Col xs={4} md={4} lg={4} className={style.smallGutter}>
            {!this.props.browser.lessThan.medium
              ? <ul className={style.list}>
                <li className={style.startedStudentsBullet}>
                  <span>Started ({this.props.startedStudents})</span>
                </li>
                <li className={style.completedStudentsBullet}>
                  <span>Completed ({this.props.completedStudents})</span>
                </li>
              </ul>
              : null}
          </Col>
        </Row>
      </div>
    )
  }
}

TargetScoreSummary.propTypes = {
  scoreTarget: PropTypes.number.isRequired,
  onEditTargetScoreClick: PropTypes.func.isRequired,
  totalStudents: PropTypes.number.isRequired,
  startedStudents: PropTypes.number,
  completedStudents: PropTypes.number,
  individualStudentSelected: PropTypes.bool.isRequired,
  browser: PropTypes.object.isRequired,
  isRestrictedInstructor: PropTypes.bool
}
